/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    HostCollaboration,
    HostCollaborationFromJSON,
    HostCollaborationFromJSONTyped,
    HostCollaborationToJSON,
} from './';

/**
 * 
 * @export
 * @interface HostCollaborationList
 */
export interface HostCollaborationList {
    /**
     * 
     * @type {Array<HostCollaboration>}
     * @memberof HostCollaborationList
     */
    data?: Array<HostCollaboration>;
}

export function HostCollaborationListFromJSON(json: any): HostCollaborationList {
    return HostCollaborationListFromJSONTyped(json, false);
}

export function HostCollaborationListFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostCollaborationList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(HostCollaborationFromJSON)),
    };
}

export function HostCollaborationListToJSON(value?: HostCollaborationList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(HostCollaborationToJSON)),
    };
}

